import { render } from "./AppHeader.vue?vue&type=template&id=84647190"
const script = {}

import "./AppHeader.vue?vue&type=style&index=0&id=84647190&lang=scss"

import exportComponent from "/Users/phil/Sites/2022lovehate/vue-starter-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__